import {
  AccountCircle,
  Assignment,
  EventNote,
  Forum,
  Home,
  RateReview,
  Reply,
  SupervisorAccount,
  Tune,
} from '@mui/icons-material'
import { createContext, ReactNode, useContext, useState } from 'react'

import { PatientChartPage } from '../../components/PatientChart/PatientChartPage'
import { Patients } from '../../views/Admin/Patients/Patients.container'
import { PeerGroups } from '../../views/Admin/PeerGroups/PeerGroups.container'
import { Providers } from '../../views/Admin/Providers/Providers.container'
import { ResourcesView } from '../../views/Admin/Resources/Resources.view'
import { Dashboard } from '../../views/Dashboard/Dashboard.container'
import Messaging from '../../views/Dashboard/Widgets/Messaging/Messaging.container'
import { Profile } from '../../views/Profile/Profile.container'
import { Schedule } from '../../views/Schedule/Schedule.container'
import { MessagesProvider } from '../Messages/Messages.provider'
import { useProviderDetails } from '../ProviderDetails/ProviderDetails.provider'
import { ResourcesProvider } from '../Resources/Resources.provider'
import { VrHeadsetProvider } from '../VrHeadset/VrHeadset.provider'
import { Navigation, NavigationContextType } from './types'

export const NavigationContext = createContext<NavigationContextType | null>(
  null
)

export const NavigationProvider = ({ children }: { children?: ReactNode }) => {
  const navigationLinks = [
    {
      Icon: <Home />,
      title: 'Home',
      route: 'home',
      View: <Dashboard />,
      useViewPaper: false,
    },

    {
      Icon: <Tune />,
      title: 'My Patients',
      route: 'myPatients',
      View: <Patients />,
    },
    {
      Icon: <SupervisorAccount />,
      title: 'Patient Chart',
      route: 'patientChart/:routedPatientId',
      View: <PatientChartPage />,
      hiddenFromNav: true,
    },

    {
      Icon: <Tune />,
      title: 'Providers',
      route: 'providers',
      View: <Providers />,
    },
    {
      Icon: <SupervisorAccount />,
      title: 'Patient Chart',
      route: 'patientChart/:routedPatientId',
      View: <PatientChartPage />,
      hiddenFromNav: true,
    },
    {
      Icon: <Tune />,
      title: 'Peer Groups',
      route: 'peerGroups',
      View: <PeerGroups />,
    },
    {
      Icon: <Tune />,
      title: 'Peer Group Detail',
      route: '/peerGroups/detail/:routedViewType/:routedPeerGroupId',
      View: <PeerGroups />,
      hiddenFromNav: true,
    },
    {
      Icon: <EventNote />,
      title: 'Schedule',
      route: 'schedule',
      View: <Schedule />,
      restricted: true,
    },
    {
      Icon: <RateReview />,
      title: 'Messages',
      route: 'messages',
      restricted: true,
    },
    {
      Icon: <Assignment />,
      title: 'Tasks',
      route: 'tasks',
      restricted: true,
    },
    {
      Icon: <SupervisorAccount />,
      title: 'Patients',
      route: 'patients',
      restricted: true,
    },
    {
      Icon: <Forum />,
      title: 'Message with...',
      route: 'messages/:routedThreadId',
      View: <Messaging isStandAloneView />,
      useViewPaper: false,
      hiddenFromNav: true,
    },
    {
      Icon: <Reply />,
      title: 'Reply',
      route: 'message/:routedMessageId',
      View: <Messaging isStandAloneView />,
      useViewPaper: false,
      hiddenFromNav: true,
    },

    {
      Icon: <AccountCircle />,
      title: 'Profile',
      route: 'account',
      View: <Profile />,
      Provider: VrHeadsetProvider,
      hiddenFromNav: true,
    },
  ]

  // To set up admin app routes; but to check actual route access, go to Main.view.tsx

  const [navigation, setNavigation] = useState<Navigation>({
    navigationLinks,
    allRoutes: navigationLinks,
  })

  return (
    <NavigationContext.Provider
      value={{
        navigation,
        setNavigation,
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}
export const useNavigation = () => {
  const context = useContext(NavigationContext)

  if (context === null) {
    return {
      navigation: {
        navigationLinks: [],
        allRoutes: [],
      },
      setNavigation: () => {},
    }
  }

  return context
}
